// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "ServicesSection-module--wrapper--STblc";
export var swiperWrapper = "ServicesSection-module--swiperWrapper--CpX4I";
export var counter = "ServicesSection-module--counter--JoFuW";
export var triangle = "ServicesSection-module--triangle--TNc8a";
export var decorator = "ServicesSection-module--decorator--42yKh";